import(/* webpackMode: "eager" */ "/repo/apps/cms/src/app/(front)/_components/LegalDocumentPage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/repo/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@opentelemetry+api@1.9.1_react-dom@19.2.5_react@19.2.5__react@19.2.5_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
